import React, { Component } from "react";
import ErrorIcon from "@material-ui/icons/Error";
import "../styles/NoticeSection.css";

class NoticeSection extends Component {
    getMessageByTicketCountry = countryCode => {
        switch (countryCode) {
            case "AU":
            case "NZ":
            case "SG":
                return "On Jan. 1-6, information on return/replacement status will not be updating due to a planned system update. Return address information for return/replacement requests during this time will be delivered via email on Jan. 7.";
            case "CA":
            case "US":
                return "From 3 p.m. EST on Dec. 31 to 11:59 p.m. EST on Jan. 5, information on return/replacement status will not be updating due to a planned system update. Return labels for return/replacement requests during this time will be delivered via email on Jan. 6.";
            case "CAFR":
                return "Du 31 décembre à 15 h HNE au 5 janvier à 23 h 59 HNE, les informations sur le statut des retours/échanges ne seront pas mises à jour en raison d'une interruption planifiée du système. Les étiquettes de retour pour les demandes de remboursement/échange effectuées pendant cette période seront envoyées par courriel le 6 janvier.";
            case "FR":
                return "Du 31 décembre à 21h au 6 janvier à 6h, les informations sur le statut des retours/échanges ne seront pas mises à jour en raison d'une interruption planifiée du système. Les étiquettes de retour pour les demandes de remboursement/échange effectuées pendant cette période seront envoyées par e-mail le 6 janvier.";
            case "IT":
                return "Dalle ore 21:00 del 31 dicembre alle ore 6:00 del 6 gennaio, le informazioni sullo stato dei resi/sostituzioni non verranno aggiornate a causa di un'interruzione programmata del sistema. Le etichette per i resi/sostituzioni richieste durante questo periodo saranno inviate via email il 6 gennaio.";
            case "BE":
                return "Gedurende 31 december 21.00 uur tot 6 januari 06.00 uur wordt de informatie over de status van retouren/vervangingen niet bijgewerkt vanwege een geplande systeemonderbreking. Retourlabels voor retour- of vervangingsaanvragen die tijdens deze periode worden ingediend, worden op 6 januari per e-mail verzonden.";
            case "BEFR":
                return "Du 31 décembre à 21h au 6 janvier à 6h, les informations sur le statut des retours/échanges ne seront pas mises à jour en raison d'une interruption planifiée du système. Les étiquettes de retour pour les demandes de remboursement/échange effectuées pendant cette période seront envoyées par e-mail le 6 janvier.";
            case "NL":
                return "Gedurende 31 december 21.00 uur tot 6 januari 06.00 uur wordt de informatie over de status van retouren/vervangingen niet bijgewerkt vanwege een geplande systeemonderbreking. Retourlabels voor retour- of vervangingsaanvragen die tijdens deze periode worden ingediend, worden op 6 januari per e-mail verzonden.";
            case "ES":
                return "Desde las 9 p.m. del 31 de diciembre hasta las 6 a.m. del 6 de enero, la información sobre el estado de devoluciones/reemplazos no se actualizará debido a una interrupción planificada del sistema. Las etiquetas de devolución para solicitudes de devolución/reemplazo realizadas durante este período se enviarán por correo electrónico el 6 de enero.";
            case "PT":
                return "Das 20h do dia 31 de dezembro até às 5h do dia 6 de janeiro, as informações sobre o status de devoluções/substituições não serão atualizadas devido a uma interrupção planeada no sistema. As etiquetas de devolução para solicitações de devolução/substituição feitas durante esse período serão enviadas por e-mail no dia 6 de janeiro.";
            case "GB":
                return "From 8 p.m. on Dec. 31 to 5 a.m. on Jan. 6, information on return/replacement status will not be updating due to a planned system update. Return labels for return/replacement requests during this time will be delivered via email on Jan. 6.";
            case "SE":
                return "Från den 31 december kl. 21.00 till den 6 januari kl. 06.00 kommer information om status för returer/ersättningar inte att uppdateras på grund av ett planerat systemavbrott. Returetiketter för retur-/ersättningsförfrågningar som görs under denna period kommer att skickas via e-post den 6 januari.";
            case "CZ":
                return "Od 31. prosince 21:00 do 6. ledna 6:00 nebudou informace o stavu vrácení/výměn aktualizovány z důvodu plánované odstávky systému. Štítky pro vrácení zboží nebo výměnu, o které bude požádáno během tohoto období, budou zaslány e-mailem 6. ledna.";
            case "PL":
                return "Od 31 grudnia o godzinie 21:00 do 6 stycznia o godzinie 6:00 informacje o statusie zwrotów/wymian nie będą aktualizowane z powodu planowanej przerwy systemowej. Etykiety zwrotne dla wniosków o zwrot/wymianę złożonych w tym okresie zostaną wysłane e-mailem 6 stycznia.";
            case "IE":
                return "From 8 p.m. on Dec. 31 to 5 a.m. on Jan. 6, information on return/replacement status will not be updating due to a planned system update. Return labels for return/replacement requests during this time will be delivered via email on Jan. 6.";
            case "RO":
                return "În perioada 31 decembrie, ora 22:00 - 6 ianuarie, ora 07:00, informațiile despre statusul returnărilor/înlocuirilor nu vor fi actualizate din cauza unei întreruperi planificate a sistemului. Etichetele de retur pentru cererile de returnare/înlocuire făcute în această perioadă vor fi trimise prin e-mail pe 6 ianuarie.";
            default:
                return "On Jan. 1-6, information on return/replacement status will not be updating due to a planned system update. Return address information for return/replacement requests during this time will be delivered via email on Jan. 7.";
        }
    };

    getReadMoreLinkTextByTicketCountry = countryCode => {
        switch (countryCode) {
            case "AU":
            case "NZ":
            case "SG":
                return "Read more here.";

            case "CA": //QC is missing
            case "US":
                return "Read more here.";
            case "CAFR":
                return "Plus d’informations ici.";
            case "FR":
                return "En savoir plus ici.";
            case "IT":
                return "Leggi di più qui.";
            case "BE":
                return "Lees hier meer.";
            case "BEFR":
                return "En savoir plus ici.";
            case "NL":
                return "Lees hier meer.";
            case "ES":
                return "Lee más aquí.";
            case "PT":
                return "Leia mais aqui.";
            case "GB":
                return "Read more here.";
            case "IE":
                return "Read more here.";
            case "RO":
                return "Citiți mai multe aici.";
            case "SE":
                return "Läs mer här.";
            case "CZ":
                return "Více informací zde.";
            case "PL":
                return "Przeczytaj więcej tutaj.";
            default:
                return "Read more here.";
        }
    };

    getReadMoreLinkByTicketCountry = countryCode => {
        switch (countryCode) {
            case "AU":
            case "NZ":
            case "SG":
            case "CA":
            case "US":
            case "ES":
            case "FR":
            case "IT":
            case "BE":
            case "NL":
            case "PT":
            case "GB":
                return `https://${countryCode.toLowerCase()}.kobobooks.com/pages/shipping-and-returns`;

            case "CAFR":
                return `https://ca.kobobooks.com/pages/shipping-and-returns`;

            case "BEFR":
                return `https://be.kobobooks.com/pages/shipping-and-returns`;

            case "IE":
            case "PL":
            case "RO":
            case "CZ":
            case "SE":
                return `https://eu.kobobooks.com/pages/shipping-and-returns`;

            default:
                return "https://us.kobobooks.com/pages/shipping-and-returns";
        }
    };

    render() {
        return (
            <div className="section personal-information-section">
                <div className="notice-section-background-placeholder">
                    <div className="section-body">
                        <div className="flex layout horizontal notice-section-body">
                            <ErrorIcon style={{ color: "BF0000", marginRight: "10px" }} />
                            <span>
                                {this.getMessageByTicketCountry(this.props.countryCode)}{" "}
                                <a className="action-button" target="_blank" href={this.getReadMoreLinkByTicketCountry(this.props.countryCode)}>
                                    {this.getReadMoreLinkTextByTicketCountry(this.props.countryCode)}
                                </a>
                            </span>
                        </div>
                        {this.props.countryCode === "CA" && (
                            <div className="flex layout horizontal notice-section-body">
                                <ErrorIcon style={{ color: "BF0000", marginRight: "10px" }} />
                                <span>
                                    {this.getMessageByTicketCountry("CAFR")}{" "}
                                    <a className="action-button" target="_blank" href={this.getReadMoreLinkByTicketCountry("CAFR")}>
                                        {this.getReadMoreLinkTextByTicketCountry("CAFR")}
                                    </a>
                                </span>
                            </div>
                        )}
                        {this.props.countryCode === "BE" && (
                            <div className="flex layout horizontal notice-section-body">
                                <ErrorIcon style={{ color: "BF0000", marginRight: "10px" }} />
                                <span>
                                    {this.getMessageByTicketCountry("BEFR")}{" "}
                                    <a className="action-button" target="_blank" href={this.getReadMoreLinkByTicketCountry("BEFR")}>
                                        {this.getReadMoreLinkTextByTicketCountry("BEFR")}
                                    </a>
                                </span>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

export default NoticeSection;
